import EducationLevel from 'modules/contracts/store/models/EducationLevel'

import { PayrollLegalEntityResource } from '../payrollLegalEntityResource'

class EducationLevels extends PayrollLegalEntityResource<EducationLevel> {
  model() {
    return EducationLevel
  }
}

export { EducationLevels }
